import { render, staticRenderFns } from "./user-icon.vue?vue&type=template&id=3687cc1a&scoped=true"
import script from "./user-icon.vue?vue&type=script&lang=js"
export * from "./user-icon.vue?vue&type=script&lang=js"
import style0 from "./user-icon.vue?vue&type=style&index=0&id=3687cc1a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687cc1a",
  null
  
)

export default component.exports